<template>
    <container bg="#f3f3f3">
      <mu-flexbox orient="vertical" class="page">
        <mu-flexbox-item>账户余额</mu-flexbox-item>
        <mu-flexbox-item class="account">{{account|money}}</mu-flexbox-item>
        <mu-flexbox-item class="tip">账户余额可以在还款时使用，默认为抵扣还款金额，也可以进行提现处理</mu-flexbox-item>
      </mu-flexbox>
      <mu-flexbox orient="vertical" class="page">
        <mu-flexbox-item>
          <router-link :to="{name: 'charge'}" @click.native="$reportLog('recharge', 'btn', '账户中心页-点击充值')">
            <mu-button text="充值" color="primary"></mu-button>
          </router-link>
        </mu-flexbox-item>
        <mu-flexbox-item>
          <router-link :to="{name: 'accountLog'}" @click.native="$reportLog('account_detail', 'btn', '账户中心页-点击账户明细')">
            <mu-button text="账户明细" color="white"></mu-button>
          </router-link>
        </mu-flexbox-item>
      </mu-flexbox>
    </container>
</template>
<style lang="less" rel="stylesheet/less" scoped="">
  @import "../../utils/_vars";

  .page {
    .mu-flexbox-item {
      margin-top: 12px !important;
    }
    background-color: #fff;
    padding: 15px 25px;
    font-size: @secondaryTextFontSize;
    color: @textDefault;

    .account {
      font-size: 28px;
      font-weight: bold;
    }

    .tip {
      font-size: @normalTextFontSize;
      color: @tip;
      padding: 0 25px;
    }

    .btn-disabled {
      border: 1px solid @line;
      opacity: 0.5;
    }
  }
</style>
<script  >
  import webapi from '../../request/webapi';
  export default {
    name: 'account',
    data: function () {
      return {
        account: null,
        coreAccountCustomerId: 0
      };
    },
    filters: {
      // 千分位
      money: function (val, n = 2) {
        if (val === null) {
          return '';
        }
        return (val.toFixed(n) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
      }
    },
    mounted: async function () {
      this.$showLoader({ text: 'Loading' });
      try {
        let result = await webapi.account.queryCustomerAccount();
        if (result.statusCode === 200) {
          this.account = Number(result.result.accountAmount);
          this.coreAccountCustomerId = Number(result.result.coreAccountCustomerId);
        }
      }
      catch (e) {
        this.$showToast({ text: '数据加载失败，请您稍后重试' });
      }
      finally {
        this.$hideLoader();
      }
    }
  };
</script>
